import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import AppBar from 'material-ui/AppBar';
import indigo from 'material-ui/colors/indigo';
import logo from '../static/img/logo.png';
import AuthContainer from './containers/AuthContainer';
import Navigation from './navigation/Navigation';

const styles = {
  Header: {
    backgroundColor: indigo[500],
  },
  headerWrapper: {
    padding: "0 2em"
  },
  logoWrapper: {
    /*display: "flex",
    justifyContent: "center",
    alignItems: "baseline",*/
  },
  logo: {
    height: '40px',
    marginTop: '15px'
  },
};

class Header extends Component {
  classes = this.props.classes;

  state = {
    showAccountPanel: true,
  };

  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
  }

  render() {
    return (
      <AppBar className={this.classes.Header}>
        <Navigation />
      </AppBar>
    );
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    window.scrollY > 100 ? this.setState({ showAccountPanel: false }) : this.setState({ showAccountPanel: true });;
  }
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js